import { Injectable } from '@angular/core'

import { Observable, map } from 'rxjs'

import {
  DataModelAttribute,
  DataModelEntity,
} from '@flowx/designer/modules/core/dictionary/data-model.dictionary'

import { DataModelApiService, DataModelRequestOptions } from './data-model.api'

import { AppResource } from '../entities/application.entity'
import {
  CreateDataModelAttributeParams,
  UpdateDataModelAttributeParams,
} from '../entities/data-model.entity'

interface TemplateAttributeResponse {
  dmAttributeDTO: DataModelAttribute
}

@Injectable({ providedIn: 'root' })
export class TemplateDataModelApiService extends DataModelApiService {
  override addAttributeToDataModelEntity(
    options: DataModelRequestOptions,
    entityId: DataModelEntity['id'],
    attribute: CreateDataModelAttributeParams
  ): Observable<AppResource<DataModelAttribute>> {
    return this.#mapAttributeResponse(
      super.addAttributeToDataModelEntity(options, entityId, attribute)
    )
  }

  override updateAttributeInDataModelEntity(
    options: DataModelRequestOptions,
    entityId: DataModelEntity['id'],
    attribute: UpdateDataModelAttributeParams,
    force = false
  ): Observable<AppResource<DataModelAttribute>> {
    return this.#mapAttributeResponse(
      super.updateAttributeInDataModelEntity(options, entityId, attribute, force)
    )
  }

  #mapAttributeResponse(
    source$: Observable<AppResource<DataModelAttribute>>
  ): Observable<AppResource<DataModelAttribute>> {
    return source$.pipe(
      map((response) => {
        const templateAttribute = response.resourceContent as Partial<TemplateAttributeResponse>
        return templateAttribute?.dmAttributeDTO
          ? { ...response, resourceContent: templateAttribute.dmAttributeDTO }
          : response
      })
    )
  }
}
